import { ChevronRight, ColoredChevronLeft, MonoLogo } from "../../../../assets/icons";
import Button, { ButtonStyle } from "../../../../common/components/button/button";
import RadioButtonLong from "../../../../common/components/radio/RadioButtonLong";
import MasterCardLogo from "../../../../assets/icons/master_card_logo.png";
import VisaLogo from "../../../../assets/icons/visa.png";
import styles from "./payment.module.css";
import { useEffect, useState } from "react";
import { useView } from "../provider/ViewContext";
import { useLazyCheckMandateConnectedQuery, useLazyGetOrderNextPaymentQuery } from "../../../../service/order-service";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../../../stores/slices/loader-slice";
import {
	useChargeInitalDepositWithCardMutation,
	useChargeMonthlyRepaymentWithCardMutation,
	useChargeRemainderWithCardMutation,
} from "../../../../service/paystack-service";
import { useNavigate } from "react-router-dom";
import { PAYMENT_CHOICE } from "../constant";
import { useChargeMonthlyRepaymentMutation, useChargeRemainderMutation } from "../../../../service/direct-debit-service";
import CongratulationsDialog from "../../../../common/components/dialog/CongratulationsDialog";
import CommonDialog from "../../../../common/components/dialog/CommonDialog";
import {
	useLazyGetWalletEnquiryQuery,
	usePayInitialDepositWithWalletMutation,
	usePayInstallmentWithWalletMutation,
	usePayRemainderWithWalletMutation,
} from "../../../../service/virtual-wallet-service";
import ConfirmationDialog from "../../../../common/components/dialog/ConfirmationDialog";
import WalletRadioButtonLong from "../../../../common/components/radio/WalletInfoRadioButton";
import { BounceLoader } from "react-spinners";

export enum PaymentChoice {
	MONO = "mono",
	CARD = "card",
	TRANSFER = "transfer",
}

const DepositComponent = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [selectedChoice, setSelectedChoice] = useState<PaymentChoice>();
	const [showSuccessModal, setShowSuccessModal] = useState(false);
	const [showPendingModal, setShowPendingModal] = useState(false);

	const { setView, orderId, paymentInfo, nextPaymentInfo } = useView();
	const [getOrderDetails, { data }] = useLazyGetOrderNextPaymentQuery();
	const [checkMandateStatus, { data: mandate }] = useLazyCheckMandateConnectedQuery();
	//paystack
	const [payViaCard] = useChargeInitalDepositWithCardMutation();
	const [payInstallmentWithCard] = useChargeMonthlyRepaymentWithCardMutation();
	const [payRemainderWithCard] = useChargeRemainderWithCardMutation();
	//mono
	const [PayNextInstallmentWithMono] = useChargeMonthlyRepaymentMutation();
	const [PayBalanceWithMono] = useChargeRemainderMutation();
	//wallet
	const [getWalletDetais, { data: walletInfo, isFetching }] = useLazyGetWalletEnquiryQuery();
	const [payInitalDepositWithWallet] = usePayInitialDepositWithWalletMutation();
	const [payInstallmentWithWallet] = usePayInstallmentWithWalletMutation();
	const [payRemainderWithWallet] = usePayRemainderWithWalletMutation();

	useEffect(() => {
		if (!nextPaymentInfo) {
			handleGetOrderDetails();
		} else {
			handleCheckMandateConnceted();
		}
		handleGetWalletInfo();
	}, []);

	const handlePayBalanceWithWallet = () => {
		dispatch(showLoader());
		payRemainderWithWallet(orderId)
			.unwrap()
			.then(res => {
				if (res?.status === "Succeeded") {
					setShowSuccessModal(true);
				}
				if (res?.status === "Pending") {
					setShowPendingModal(true);
				}
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handlePayInstallmentWithWallet = () => {
		dispatch(showLoader());
		payInstallmentWithWallet(orderId)
			.unwrap()
			.then(res => {
				if (res?.status === "Succeeded") {
					setShowSuccessModal(true);
				}
				if (res?.status === "Pending") {
					setShowPendingModal(true);
				}
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handlePayInitialDepositWithWallet = () => {
		dispatch(showLoader());
		payInitalDepositWithWallet(orderId)
			.unwrap()
			.then(res => {
				if (res?.status === "Succeeded") {
					setShowSuccessModal(true);
				}
				if (res?.status === "Pending") {
					setShowPendingModal(true);
				}
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handleGetWalletInfo = () => {
		getWalletDetais()
			.unwrap()
			.then()
			.catch(err => toast.error(err?.data?.title as string));
	};

	const handleSelectOption = (selected: PaymentChoice) => {
		setSelectedChoice(selected);
	};

	const handleCheckMandateConnceted = () => {
		dispatch(showLoader());
		checkMandateStatus(orderId)
			.unwrap()
			.then()
			.finally(() => dispatch(hideLoader()));
	};

	const handleGetOrderDetails = () => {
		dispatch(showLoader());
		getOrderDetails(orderId)
			.unwrap()
			.then()
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handleCardPayment = () => {
		dispatch(showLoader());
		payViaCard(orderId)
			.unwrap()
			.then(res => {
				setShowSuccessModal(true);
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handleCardBalancePayment = () => {
		dispatch(showLoader());
		payRemainderWithCard(orderId)
			.unwrap()
			.then(() => {
				setShowSuccessModal(true);
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handleCardNextInstallmentPayment = () => {
		dispatch(showLoader());
		payInstallmentWithCard(orderId)
			.unwrap()
			.then(() => {
				setShowSuccessModal(true);
			})
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handleMonoNextInstallment = () => {
		dispatch(showLoader());
		PayNextInstallmentWithMono(orderId)
			.unwrap()
			.then(res => setShowSuccessModal(true))
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handleMonoBalancePayment = () => {
		dispatch(showLoader());
		PayBalanceWithMono(orderId)
			.unwrap()
			.then(res => setShowSuccessModal(true))
			.catch(err => toast.error(err?.data?.title as string))
			.finally(() => dispatch(hideLoader()));
	};

	const handleProceed = () => {
		if (!selectedChoice) {
			toast.warning("You need to select a payment choice");
			return;
		}
		if (selectedChoice === PaymentChoice.CARD) {
			if (nextPaymentInfo?.isDeposit || data?.isDeposit) {
				handleCardPayment();
				return;
			}
			if (paymentInfo?.paymentChoice === PAYMENT_CHOICE.BALANCE) {
				handleCardBalancePayment();
				return;
			}

			if (paymentInfo?.paymentChoice === PAYMENT_CHOICE.NEXT_INSTALLMENT) {
				handleCardNextInstallmentPayment();
				return;
			}
		}

		if (selectedChoice === PaymentChoice.MONO) {
			if (paymentInfo?.paymentChoice === PAYMENT_CHOICE.BALANCE) {
				handleMonoBalancePayment();
			}
			if (paymentInfo?.paymentChoice === PAYMENT_CHOICE.NEXT_INSTALLMENT) {
				handleMonoNextInstallment();
			}
		}

		if (selectedChoice === PaymentChoice.TRANSFER) {
			if (nextPaymentInfo?.isDeposit || data?.isDeposit) {
				handlePayInitialDepositWithWallet();
				return;
			}
			if (paymentInfo?.paymentChoice === PAYMENT_CHOICE.BALANCE) {
				handlePayBalanceWithWallet();
				return;
			}
			if (paymentInfo?.paymentChoice === PAYMENT_CHOICE.NEXT_INSTALLMENT) {
				handlePayInstallmentWithWallet();
				return;
			}
		}
	};

	return (
		<>
			{showSuccessModal && (
				<CongratulationsDialog
					description={nextPaymentInfo ? "Repayment was successful" : "Your Order is on it's way to you"}
					onConfirm={() => {
						window.location.href = `${window.location.origin}/customer/dashboard`;
					}}
				/>
			)}
			{showPendingModal && (
				<CommonDialog onCloseDialog={() => {}}>
					<div className={styles.paymentSuccessContainer}>
						<div className={styles.title}>Your payment is pending!</div>
						<div className={styles.description}>You will be notified of the status via email</div>
						<div className={styles.buttonContainer}>
							<button
								className={`standardButton ${styles.button} ${styles.pauseButton}`}
								onClick={() => (window.location.href = `${window.location.origin}/customer/dashboard`)}
							>
								Proceed
							</button>
						</div>
					</div>
				</CommonDialog>
			)}

			<div className={styles.container}>
				<div className={styles.wrapper}>
					<div className={styles.header}>
						<Button
							rightIcon={<ColoredChevronLeft />}
							title="Back"
							style={ButtonStyle.WHITE}
							onClick={() => (paymentInfo ? setView("repayment") : setView("authorizePayment"))}
						/>
						<div className={styles.title}>
							<div className={styles.titleHeader}>Congratulations!</div>
							<p className={styles.subTitle}>Just one more step and your solar system is on it’s way to you</p>
						</div>
						<Button style={ButtonStyle.DARK} title="Make Payment" leftIcon={<ChevronRight />} onClick={handleProceed} />
					</div>
					<div className={styles.optionHeader}>{`How would you like to make your ${data?.isDeposit ? `30% Initial Deposit` : "next payment"}?`}</div>

					<RadioButtonLong
						leftSection={<span>Amount Due</span>}
						middleSection={<span>₦{data?.isDeposit ? data?.amount.toLocaleString() : paymentInfo?.amount.toLocaleString()}</span>}
						isSelected={false}
						label={data?.isDeposit ? "30% Initial Deposit" : paymentInfo?.paymentChoice === PAYMENT_CHOICE.BALANCE ? "Outstanding Balance" : "Next Installment"}
						isHidden
						onSelected={() => {}}
					/>
					<RadioButtonLong
						label="Your saved cards"
						leftSection={
							<div className={styles.cardLink}>
								{(data?.paystackCardInformation?.brand || nextPaymentInfo?.paystackCardInformation?.brand) === "visa" ? (
									<img className={styles.cardIcon} src={VisaLogo} alt="card logo" />
								) : (
									<img className={styles.cardIcon} src={MasterCardLogo} alt="card logo" />
								)}
								<span>**** **** {data?.paystackCardInformation?.last4 || nextPaymentInfo?.paystackCardInformation?.last4}</span>
							</div>
						}
						isSelected={selectedChoice === PaymentChoice.CARD}
						onSelected={() => handleSelectOption(PaymentChoice.CARD)}
					/>

					{/* Can't use mono to pay initial deposit */}
					{!nextPaymentInfo && mandate?.monoDirectDebitConnected && (
						<RadioButtonLong
							label="Mono DirectPay ( One time Payment)"
							leftSection={<Button rightIcon={<MonoLogo />} title="Pay with mono" style={ButtonStyle.LONG} />}
							isSelected={selectedChoice === PaymentChoice.MONO}
							onSelected={() => handleSelectOption(PaymentChoice.MONO)}
						/>
					)}
					<WalletRadioButtonLong
						isSelected={selectedChoice === PaymentChoice.TRANSFER}
						onSelected={() => handleSelectOption(PaymentChoice.TRANSFER)}
						label="Your Dedicated Account Balance"
						subLabel="Please ensure the wallet is well funded with the right amount"
						leftSection={<span>Account Details</span>}
						middleSection={isFetching ? <BounceLoader /> : <></>}
						data={walletInfo}
					/>
				</div>
				<div className={styles.bottomControl}>
					<Button
						rightIcon={<ColoredChevronLeft />}
						title="Back"
						style={ButtonStyle.WHITE}
						onClick={() => (paymentInfo ? setView("repayment") : setView("authorizePayment"))}
					/>
					<Button disbaled={false} style={ButtonStyle.DARK} title="Make Payment" leftIcon={<ChevronRight />} onClick={handleProceed} />
				</div>
			</div>
		</>
	);
};
export default DepositComponent;
